import React from 'react';
import { connect } from 'react-redux';

const pdf1805DocUrl = (id) => {
   return `/lgyhub/api/appraiser-workspace/property-appraisal/${id}/1805`
}

const AssignmentDocumentContainer = ({ assignmentDetails }) => 
<> 
    <a href={pdf1805DocUrl(assignmentDetails.id)} target="_blank" rel="noopener noreferrer">View/Print</a>
    <embed src={pdf1805DocUrl(assignmentDetails.id)} width="800px" height="1100px" />
</>

const mapStateToProps = (state) => ({
  user: state.currentUser
})

export default connect(mapStateToProps)(AssignmentDocumentContainer)
